import React from 'react'
import './Icon.scss'
const rootClassName = 'icon-component'

export const InformationIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z'
        fill='none'
        stroke='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.05 7.5C11.6358 7.5 11.3 7.83579 11.3 8.25C11.3 8.66421 11.6358 9 12.05 9C12.4642 9 12.8 8.66421 12.8 8.25C12.8 7.83579 12.4642 7.5 12.05 7.5Z'
        fill='currentColor'
      />
      <path
        d='M12 16.5V10.5'
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
      />
    </svg>
  )
}
